import styled from 'styled-components/macro';

// utils
import mq from '../../utils/mediaQueriesBp';

// components
import ResponsiveContainer from '../../components/layout/ResponsiveContainer';
import Button from '../../atoms/Button';
import H3 from '../../atoms/H3';
import { NavLink } from 'react-router-dom';
import ReactPlayer from 'react-player';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-top: 30px;
  padding-bottom: 60px;
`;

const VideoList = styled(ResponsiveContainer)`
  justify-content: space-between;
  flex-wrap: wrap;
  &::after {
    content: '';
    flex: 0.9;
  }
`;

const Title = styled(H3)`
  margin-bottom: 10px;
  font-weight: 700;
`;

const VideoItem = styled.div`
  display: flex;
  //max-width: 250px;
  flex: 0 1 100%;
  flex-direction: column;
  cursor: pointer;
  background: white;
  margin-bottom: 20px;
  transition: all 0.5s ease-in-out;

  &:hover {
    ${Title} {
      color: ${props => props.theme.colors.darkBlue};
    }
  }

  ${mq('laptop')} {
    flex: 0 1 48%;
    margin-bottom: 40px;
  }

  ${mq('desktop')} {
    flex: 0 1 32%;
    margin-bottom: 60px;
  }
`;

const VideoContainer = styled.div`
  width: 100%;
  position: relative;
  padding-top: 56.25%;
  margin-bottom: 20px;
`;

const VideoPreviewItem = styled(ReactPlayer)`
  position: absolute;
  top: 0;
  left: 0;
`;

const VideoDescription = styled.p`
  max-width: 100%;
  margin-top: 25px;
  margin-bottom: 25px;
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const CreatedAt = styled.p`
  font-size: 16px;
  line-height: 18px;
  font-weight: 300;
`;

const Link = styled(NavLink)`
  width: 100%;
  text-decoration: none;
`;

const PolicyText = styled.p`
  margin-bottom: 15px;
`;
const PolicyButton = styled(Button)``;
const PolicyContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const Wrapper2 = styled(ResponsiveContainer)`
  flex-wrap: wrap;
  height: auto;
  overflow-y: auto;
`;

export {
  Wrapper,
  Wrapper2,
  VideoList,
  VideoItem,
  VideoContainer,
  VideoPreviewItem,
  Title,
  Row,
  CreatedAt,
  Link,
  VideoDescription,
  PolicyContainer,
  PolicyText,
  PolicyButton,
};
